import { render, staticRenderFns } from "./DistributorPayments.vue?vue&type=template&id=2ea34b76&scoped=true"
import script from "./DistributorPayments.vue?vue&type=script&lang=js"
export * from "./DistributorPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea34b76",
  null
  
)

export default component.exports